module.exports = __webpack_public_path__ + "images/51441330485f781750bd659fd3b241f0.png";